import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

import { Co2QuizQuestion } from '@/models/co2-quiz.model';
import { PropType, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2QuizPartQuestionsField',
  props: {
  modelValue: {
    type: Object as PropType<Co2QuizQuestion>,
    required: true,
  },
  questions: {
    type: Array as PropType<Co2QuizQuestion[]>,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const value = ref<Co2QuizQuestion>({
  ...props.modelValue,
  partQuestions: [
    ...props.questions.filter(
      (q) => q.partQuestion?.id === props.modelValue.id,
    ),
  ],
});

const emit = __emit;

const update = () => {
  emit('update:modelValue', value.value);
};

const showAddQuestions = ref<boolean>(false);
const addableQuestions = ref<Co2QuizQuestion[]>([]);

function toggleAddQuestions() {
  showAddQuestions.value = !showAddQuestions.value;
}

function addParts() {
  if (addableQuestions.value) {
    value.value.partQuestions = value.value.partQuestions = [
      ...(value.value.partQuestions || []),
      ...addableQuestions.value,
    ];
    update();
  }
  addableQuestions.value = [];
}

function removePart(index: number) {
  const list = [...(value.value.partQuestions || [])];

  list.splice(index, 1);

  value.value.partQuestions = list;
  update();
}

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Parts", -1)),
      (!(value.value.partQuestions || []).length)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "info",
            density: "compact"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Parts will be displayed on the same page as this question. This question will serve only as the page, not as an actual question. ")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.value.partQuestions || [], (q, index) => {
            return (_openBlock(), _createBlock(_component_v_card, {
              class: "mb-2",
              style: {"padding":"8px"},
              key: q.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(q.title) + " ", 1),
                _createVNode(_component_v_btn, {
                  icon: "mdi-delete-outline",
                  class: "remove-button",
                  density: "compact",
                  onClick: _withModifiers(($event: any) => (removePart(index)), ["prevent"])
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        width: "auto",
        scrollable: ""
      }, {
        activator: _withCtx(({ props: activatorProps }) => [
          _createVNode(_component_v_btn, _mergeProps(activatorProps, {
            onClick: toggleAddQuestions,
            color: "success"
          }), {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Add part")
            ])),
            _: 2
          }, 1040)
        ]),
        default: _withCtx(({ isActive }) => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_radio_group, {
                    multiple: "",
                    modelValue: addableQuestions.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addableQuestions).value = $event)),
                    messages: "Select questions to add"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...__props.questions].filter(
                  (q) =>
                    !(value.value.partQuestions || [])
                      .map((pq) => pq.id)
                      .includes(q.id),
                ), (question) => {
                        return (_openBlock(), _createBlock(_component_v_radio, {
                          key: question.id,
                          label: question.title,
                          value: question
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    text: "Close",
                    onClick: ($event: any) => (isActive.value = false)
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    onClick: ($event: any) => {
                isActive.value = false;
                addParts();
              },
                    color: "success"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Add parts")
                    ])),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})